export default {
  KEY_LEVEL_1: 'xywWhTaLoJ',
  KEY_LEVEL_3: 'pxQTvzjXxM',
  KEY_LEVEL_5: 'qtOsEEpdjP',
  KEY_LEVEL_7: 'PsmMjKlqhz',
  KEY_LEVEL_10: 'jwiSkAZpqg',
};